import React from 'react';
import styled from 'styled-components';
import { Space, Text } from 'components';

import {
  BodyText,
  ContactCard,
  ContentSpace,
  PhoneText,
  TitleText,
} from './styledComponents';

interface Props {
  answeringServicePhone: string | undefined;
}

export const AnsweringServiceActiveContent = ({
  answeringServicePhone,
}: Props) => (
    <ContentSpace size="middle" direction="vertical">
      <StyledTitleWrapper>
        <TitleText>
          The live concierge service is active for this listing
        </TitleText>
      </StyledTitleWrapper>

      <BodyText type="secondary">
        Add the following phone number to your brokerage’s listings on the MLS,
        or redirect any existing showing related phone numbers to this number,
        to begin accepting showing requests for your listings over the phone:
      </BodyText>

      <ContactCard size="small">
        <Space size="small" align="center" direction="vertical">
          <Text type="secondary">Paste this on your listing</Text>
          <PhoneText>{answeringServicePhone}</PhoneText>
        </Space>
      </ContactCard>
    </ContentSpace>
  );

export const StyledTitleWrapper = styled.div`
  width: 320px;
`;
